// Weight/distance display helpers — metric (kg/km) or imperial (lb/mi).
const KG_TO_LB = 2.20462;
const KM_TO_MI = 0.621371;

export const weightLabel = (kg, system = "metric") =>
  system === "imperial"
    ? `${(Number(kg || 0) * KG_TO_LB).toLocaleString(undefined, { maximumFractionDigits: 0 })} lb`
    : `${Number(kg || 0).toLocaleString(undefined, { maximumFractionDigits: 1 })} kg`;

export const distanceLabel = (km, system = "metric") =>
  system === "imperial"
    ? `${(Number(km || 0) * KM_TO_MI).toLocaleString(undefined, { maximumFractionDigits: 0 })} mi`
    : `${Number(km || 0).toLocaleString(undefined, { maximumFractionDigits: 0 })} km`;

export const weightUnit = (system = "metric") => (system === "imperial" ? "lb" : "kg");

// Countries that conventionally use pounds/miles — used to default a user's unit system.
export const IMPERIAL_COUNTRIES = ["US", "LR", "MM", "GB"];
export const defaultUnitSystem = (country) =>
  IMPERIAL_COUNTRIES.includes(String(country || "").toUpperCase()) ? "imperial" : "metric";
